export default "__VITE_ASSET__BhbAzV7y__"